var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-cp-horizontal-card-list--horizontal-card-list-item",class:{
    'is-white-background': _vm.isWhiteBackground,
    'has-radius': _vm.hasRadius,
  }},[_c('div',{directives:[{name:"ripple",rawName:"v-ripple",value:(
      _vm.isClickable ? { class: 'blue-grey--text text--lighten-4' } : false
    ),expression:"\n      isClickable ? { class: 'blue-grey--text text--lighten-4' } : false\n    "}],staticClass:"c-cp-horizontal-card-list--horizontal-card-list-item__content",class:{ 'is-clickable': _vm.isClickable }},[_vm._t("default")],2),_vm._v(" "),_vm._t("card-footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }